
import { DataGrid } from '@mui/x-data-grid';
import "./testimonialsDataTable.scss";
import { GridToolbar } from '@mui/x-data-grid/internals';
import deleteIcon from "../../images/delete.svg";
import viewIcon from "../../images/view.svg";
import { Link } from "react-router-dom";
import { useState } from 'react';
import MsgBox from '../msgbox/MsgBox';



const TestimonialsDataTable = (props) => {

    const [open, setOpen] = useState(false);
    const [selectedId, setSelectedId] = useState();

    //const sortedArray = props.rows.sort((a, b) => new Date(b.testimonyDate.split("-").reverse().join("-")).getTime() - new Date(a.testimonyDate.split("-").reverse().join("-")).getTime());

    const actionColumn = {
        field: 'action',
        headerName: 'Action',
        width: 200,
        renderCell: (params) => {
            return (
                <div className='action'>
                    <Link to={`/cpanel/manager/testimonials/${params.row.id}`}>
                        <img src={viewIcon} alt="" />
                    </Link>
                    <div><img src={deleteIcon} width={24} height={24} alt="" onClick={() => { setOpen(true); setSelectedId(params.row.id); }} /></div>
                </div>

            );
        },

    };

    return (
        <div className="dataTable">
            <DataGrid
                className='dataGrid'
                rows={props.rows}
                columns={[...props.columns, actionColumn]}
                initialState={{
                    pagination: {
                        paginationModel: {
                            pageSize: 10,
                        },
                    },
                }}
                showToolbar={true}
                slots={{ toolbar: GridToolbar }}
                slotProps={{
                    toolbar: {
                        showQuickFilter: true,
                        quickFilterProps: { debounceMs: 500 }
                    },
                }}
                pageSizeOptions={[10]}
                checkboxSelection
                disableRowSelectionOnClick
                disableColumnSelectorOnClick
                disableDensitySelector
                disableColumnSelector
            />

            {open && <MsgBox id={selectedId} setOpen={setOpen} />}
        </div>
    )
}

export default TestimonialsDataTable